import { Injectable } from '@angular/core';
import {
    Requisito, RequisitoOrden
} from "../../tramites/components/interfaces/tramites.interface";
import {environment} from "../../../../environments/environment.development";
import {HttpClient} from "@angular/common/http";
import {CatalogoInterface, RequisitosFormulario} from "../../interfaces/proyecto.interface";
let apiVucUrl = environment.apiVucUrl
@Injectable({
  providedIn: 'root'
})
export class RequisitoService {

  constructor(private http: HttpClient) { }
    getRequisitos(estado:string) {
        let url = apiVucUrl + `api/v1.0/requisitos?estado=${estado}`;
        return this.http.get<Requisito[]>(url)
    }
    getTipos() {
        let url = apiVucUrl + `api/v1.0/requisitos/tipos`;
        return this.http.get<CatalogoInterface[]>(url)
    }
    /**
     Este metodo muestra los requisitos que estan relacionado con los formularios de la base de datos
     1=FA (Formulario A)
     2=FB (Formulario B)
     3=FC (Formulario C)
     4=FU (Formulario Unico)
     */
    getActivosRequisitosFormulario() {
        const idFormulario = 4;
        return this.http.get<RequisitosFormulario[]>(apiVucUrl + `api/v1.0/tramites/requisitos/activos-requisitos-formulario/${idFormulario}/`)
    }
    /**
     *Muestra los requisitos que son planos y que se van a seleccionar en el FU
     */
    getActivosRequisitoPlanos() {
        return this.http.get<RequisitosFormulario[]>(apiVucUrl + `api/v1.0/tramites/requisitos/activos-requisitos-planos`)
    }
    /**Procesar update estado de los requisitos
     * */
    actualizarEstado(estado:boolean,idsRequisitos:number[]){
        let url = apiVucUrl + `api/v1.0/requisitos/estado?valor=${estado}`;
        return this.http.put<Requisito[]>(url, idsRequisitos,{observe: 'response'});
    }

    /**Procesar el registro de los requisitos
     * */
    procesarSaveRequisito(requisito:Requisito){
        let url = apiVucUrl + `api/v1.0/requisitos/`;
        return this.http.post<Requisito>(url, requisito,{observe: 'response'});
    }
    /**Procesar el actualizar de los requisitos
     * */
    procesarEditRequisito(requisito:Requisito){
        let url = apiVucUrl + `api/v1.0/requisitos/`;
        return this.http.put<Requisito>(url, requisito,{observe: 'response'});
    }
    actualizarOrdenRequisitos(requisitoOrden: RequisitoOrden[]) {
        console.log(`actualizarOrdenRequisitos ->${JSON.stringify(requisitoOrden)}`)
        return this.http.put<RequisitoOrden[]>(apiVucUrl + `api/v1.0/requisitos/orden`, requisitoOrden, {observe: 'response'})
    }


}
